import { render, staticRenderFns } from "./OxygenationIndexOI.vue?vue&type=template&id=f36a68b2&scoped=true"
import script from "./OxygenationIndexOI.vue?vue&type=script&lang=js"
export * from "./OxygenationIndexOI.vue?vue&type=script&lang=js"
import style0 from "./OxygenationIndexOI.vue?vue&type=style&index=0&id=f36a68b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36a68b2",
  null
  
)

export default component.exports